import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersFacade } from '@app/shared/+state/users';
import { SignupStatusError } from '@app/shared/+state/users/users.models';
import { LoadingState, LocalStorageKey, QueryParams, combineLoadingStates } from '@app/shared/interfaces';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-signup-status',
  templateUrl: './signup-status.component.html',
  styleUrls: ['./signup-status.component.scss'],
})
export class SignupStatusComponent implements OnInit {
  pageLoadingState$: Observable<LoadingState>;
  LoadingState = LoadingState;
  code: string;
  state: string;

  constructor(
    private usersFacade: UsersFacade,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params: any) => {
      const error = params[QueryParams.AirbnbError];
      const code = params[QueryParams.AirbnbCode];
      const state = params[QueryParams.AirbnbState];

      if (code && state) {
        if (localStorage.getItem(LocalStorageKey.signUpAirbnbState) !== state) {
          this.redirectToWelcome(SignupStatusError.InvalidState);
        } else {
          this.code = code;
          this.state = state;

          this.init();
        }
      }

      if (error) {
        this.redirectToWelcome(
          error === SignupStatusError.Denied ? SignupStatusError.Denied : SignupStatusError.Unknown
        );
      }
    });
  }

  redirectToWelcome(error: SignupStatusError) {
    this.router.navigate(['/user/register/welcome'], {
      queryParams: {
        error,
      },
    });
  }

  init() {
    this.pageLoadingState$ = combineLatest(this.usersFacade.signUpWithAirbnbLoadingState$).pipe(
      map(([signUpWithAirbnbLoadingState]) => combineLoadingStates([signUpWithAirbnbLoadingState]))
    );
    this.usersFacade.signUpWithAirbnbCallback(this.code, this.state);
  }
}
